import { useCallback, useState } from "react";
import { useSelector } from "react-redux";
import { dispatch, getState } from "../../state/store";
import {
  resetReleaseNotesMedia,
  resetReleaseNotesThumbnails,
  setReleaseNotes,
  setReleaseNotesLoading
} from "../../state/ducks";
import { selectReleaseNotesMedia } from "../../state/selectors";

import { releaseNoteOptions, releaseNotesErrors, strCode } from "../../consts";
import { log, notificationService, releaseNotesService, t } from "../../services";

export const useFetchReleaseNotes = () => {
  const releaseNotes = useSelector((store) => store.fwuVersions?.releaseNotes);

  const loading = useSelector((store) => store.fwuVersions?.releaseNotesLoading);
  const [error, setError] = useState(null);

  const setReleaseNotesImages = (releaseNotes, onSaveReleaseNotes) => {
    const { releaseNotesMedia, releaseNotesThumbnails } = selectReleaseNotesMedia()(getState());

    const releaseNotesType = releaseNotes?.releaseNotesType;
    let updatedReleaseNotes;

    if (
      releaseNotes &&
      releaseNotesType !== releaseNoteOptions.SIMPLE_LIST &&
      (releaseNotesMedia || releaseNotesThumbnails)
    ) {
      updatedReleaseNotes = {
        ...releaseNotes,
        media: releaseNotesMedia,
        thumbnails: releaseNotesThumbnails
      };
    }

    saveReleaseNotes(updatedReleaseNotes ? updatedReleaseNotes : releaseNotes, onSaveReleaseNotes);
  };

  const saveReleaseNotes = (releaseNotes, onSaveReleaseNotes) => {
    if (onSaveReleaseNotes) {
      onSaveReleaseNotes(releaseNotes);
    } else {
      dispatch(setReleaseNotes(releaseNotes));
    }

    dispatch(setReleaseNotes(releaseNotes));
  };

  const fetchCallback = useCallback(async (version, onSaveReleaseNotes) => {
    setError(null);

    if (releaseNotes?.length || loading) {
      return;
    }

    dispatch(setReleaseNotesLoading(true));

    try {
      dispatch(setReleaseNotes(null));
      dispatch(resetReleaseNotesMedia());
      dispatch(resetReleaseNotesThumbnails());
      const releaseNotes = await releaseNotesService.fetchReleaseNotes(version);

      setReleaseNotesImages(releaseNotes, onSaveReleaseNotes);
    } catch (err) {
      log.error("useFetchReleaseNotes: Failed to fetch release notes", err);

      setError(err);

      const errorMessage = err?.response?.data?.error;

      if (errorMessage !== releaseNotesErrors.RELEASE_NOTES_NOT_FOUND) {
        notificationService.showError({
          title: t(strCode.FETCH_RELEASE_NOTES_ERROR),
          message: errorMessage ? errorMessage : err?.toString()
        });
      }

      if (onSaveReleaseNotes) {
        onSaveReleaseNotes(null);
      }
    } finally {
      dispatch(setReleaseNotesLoading(false));
    }
  }, []);

  return { fetchCallback, data: releaseNotes, loading, error };
};
